import { useParams } from "react-router-dom";

import styles from "./SupportBoard.module.css";
import ListBoard from "Page/common/ListBoard";

export default function SupportBoard() {
  const { category_id } = useParams();

  const titles = ["공지사항", "자료실"];

  return (
    <div className={styles.SupportBoard}>
      <ListBoard
        category_id={category_id}
        api="support"
        title={titles[category_id - 1]}
      />
    </div>
  );
}
